// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1WXHC","footer":"Form_footer__3nndV"};